import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

const FAQSection = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqs = [
    {
      question: "What types of home loans do you offer?",
      answer: "We offer loans for home construction, plot purchase with construction, buying new or old houses, home extension, renovation and NRI home loans."
    },
    {
      question: "Who can apply for a personal loan?",
      answer: "Salaried individuals and self-employed professionals are eligible for personal loans"
    },
    {
      question: "Do I need collateral free for a unsecured business loan?",
      answer: "No, unsecured business loans do not require any collateral."
    },
    {
      question: "Do you provide loans for doctors?",
      answer: "Yes, we offer customized loan solutions exclusively for medical professionals."
    },
    {
      question: "What types of vehicle loans do you offer?",
      answer: "We provide loans for New and used two-wheelers, New and pre-owned cars, Commercial vehicles, and Tractors."
    }
  ];

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="py-12 md:py-16 lg:py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-t from-blue-50 to-white m-6 rounded-2xl shadow-lg">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-8 md:mb-12">
          <h5 className="text-2xl sm:text-3xl font-bold text-[#1e4d91] mb-2">FAQ</h5>
          <p className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-800 mb-4">Frequently asked questions</p>
          <p className="text-lg md:text-xl text-gray-600 max-w-2xl mx-auto">There's no such thing as too many questions</p>
        </div>

        <div className="space-y-4 md:space-y-5">
          {faqs.map((faq, index) => (
            <div 
              key={index}
              className="border border-gray-200 hover:border-blue-300 rounded-xl overflow-hidden shadow-sm transition-all duration-200 hover:shadow-md"
            >
              <button
                className="w-full flex justify-between items-center p-5 md:p-6 text-left bg-white hover:bg-blue-50 transition-colors"
                onClick={() => toggleFAQ(index)}
                aria-expanded={activeIndex === index}
                aria-controls={`faq-content-${index}`}
              >
                <h6 className="text-lg md:text-xl font-semibold text-[#1e4d91] text-left">
                  {faq.question}
                </h6>
                {activeIndex === index ? (
                  <ChevronUp className="h-5 w-5 text-blue-600 flex-shrink-0 ml-4" />
                ) : (
                  <ChevronDown className="h-5 w-5 text-blue-600 flex-shrink-0 ml-4" />
                )}
              </button>

              <div
                id={`faq-content-${index}`}
                className={`px-5 md:px-6 pb-5 md:pb-6 pt-0 bg-white transition-all duration-300 ease-in-out ${
                  activeIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0 overflow-hidden'
                }`}
              >
                <div className="pt-2 pb-4">
                  <p className="text-gray-600 leading-relaxed md:leading-loose text-base md:text-lg">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;